import { Component, Input, OnInit } from '@angular/core';
import { Region } from 'src/app/model/Cuentas.model';

@Component({
  selector: 'app-plan-mejora-asesor-view',
  templateUrl: './plan-mejora-asesor-view.component.html',
  styleUrls: ['./plan-mejora-asesor-view.component.css']
})
export class PlanMejoraAsesorViewComponent implements OnInit {

  @Input() region : Region;
  
  constructor() { }

  ngOnInit(): void {
  }

}
